import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { RuleAdvancedNotificationsSmsAuditFailureActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function RuleAdvancedNotificationsSmsAuditFailure({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as RuleAdvancedNotificationsSmsAuditFailureActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信模板或签名审核失败</ItemWrapper>
}
